import { formatCurrency, type Challan } from '../data/challans';
import styles from './PayNowBar.module.css';

interface PayNowBarProps {
  challans: Challan[];
}

export function PayNowBar({ challans }: PayNowBarProps) {
  const unpaid = challans.filter((c) => c.status === 'Unpaid');
  const totalDue = unpaid.reduce((sum, c) => sum + c.amount, 0);

  if (unpaid.length === 0) return null;

  return (
    <div className={styles.bar}>
      <div className={styles.barContent}>
        <div className={styles.dueInfo}>
          <span className={styles.dueCount}>{unpaid.length} unpaid challan{unpaid.length === 1 ? '' : 's'}</span>
          <span className={styles.dueAmount}>{formatCurrency(totalDue)}</span>
        </div>
        <button className={styles.payBtn} type="button">
          Pay Now
        </button>
      </div>
    </div>
  );
}
